import React, { Component } from "react";

const Calender = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M0.932892 5.87754H12.0729"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.27629 8.31895H9.28208"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.50288 8.31895H6.50867"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.72368 8.31895H3.72947"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.27629 10.7467H9.28208"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.50288 10.7467H6.50867"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.72368 10.7467H3.72947"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.02732 1.25V3.30674"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.97843 1.25V3.30674"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.14892 2.23633H3.85685C2.02142 2.23633 0.875 3.25879 0.875 5.13822V10.7942C0.875 12.7032 2.02142 13.7493 3.85685 13.7493H9.14313C10.9843 13.7493 12.125 12.721 12.125 10.8415V5.13822C12.1308 3.25879 10.9901 2.23633 9.14892 2.23633Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Calender.defaultProps = {
  width: "13",
  height: "14",
  fill: "#000",
};

export default Calender;
